<template>
  <div id="search" v-if="IsActive">
    <!-- <pre class="has-text-left">{{sorted}}</pre> -->

    <div class="results">
      <!-- items -->
      <div class="item" v-for="(r, i) in result" :key="i" v-if="r.type === 'item'" :class="{'is-selected': selectedResult == i}">
        <img :src="$pkImg('sprite-small', r.identifier)" alt="" width="30" height="30">
        <span class="id is-hidden">{{r.id}}</span>
        <p class="name title is-size-6">{{r.name}}</p>
        <p class="category-name subtitle is-size-7">{{r.category_name}}</p>
        <pre>{{r}}</pre>
      </div>
      <div class="is-clearfix"></div>

      <!-- pokemon -->
      <div class="pokemon" v-for="(r, i) in result" :key="i" v-if="r.type === 'pokemon' && r.is_default === 1" :class="{'is-selected': selectedResult == i}">
        <!-- <a @click="goPokemon((r.forms && r.forms[0].is_battle_only === 0) ? r.identifier : r.species_identifier)"> -->
        <a @click="goPokemon(r.identifier)">
          <div class="imgwrap">
            <img :src="$pkImg('small', r.identifier, r.id)" alt="" @error="$imgErr($event, 'sprite')">
          </div>
          <span class="id is-hidden">{{$padNumber(r.id, 3)}}</span>
          <span class="identifier is-hidden">{{r.identifier}}</span>
          <span class="species-name title">{{r.species_name}}</span>
        </a>
        <p class="types">
          <pokemon-type :id="id" small v-for="id in $commaStringToArray(r.type_id)" :key="id"></pokemon-type>
        </p>
        <div class="forms" v-if="r.forms">
          <b-tooltip :label="f.form_name" type="is-dark" v-for="(f, fi) in r.forms" :key="fi">
            <img :src="$pkImg('sprite-small', f.identifier)" :alt="f.identifier" width="40" height="30" @click="goPokemon(f.identifier)">
          </b-tooltip>
        </div>
        <!-- <pre>{{r}}</pre> -->
      </div>

      <div v-if="resultHasMore">
        <span class="icon">
          <i class="mdi mdi-dots-horizontal"></i>
        </span>
      </div>

      <div class="query" v-if="query">
        <span>{{query}}</span>
        <b-tooltip label="(ESC)" type="is-light">
          <span class="icon reset" @click="reset()">
            <i class="mdi mdi-window-close"></i>
          </span>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import config from '../../config'
import {mapActions, mapGetters} from 'vuex'
import PokemonType from '../PokemonType'

export default {
  components: {
    PokemonType,
  },
  data() {
    return {
      query: '',
      minQueryLength: 2,
      maxQueryLength: 20,
      allowedChars: 'abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-+'.split(''),
      fusejs: {
        all: null,
        options: {
          shouldSort: true,
          threshold: 0.2,
          location: 0,
          distance: 100,
          maxPatternLength: 20,
          minMatchCharLength: 1,
          // keys: ['identifier', 'forms.identifier', 'name'],
          keys: ['name', 'forms.identifier', 'identifier'],
        },
        delay: {
          v: null,
          t: 50,
        }
      },
      result: [],
      maxResult: 8,
      selectedResult: -1,
      resultHasMore: false,
      sorted: null,
      paths: config.paths,
    }
  },
  watch: {
    PokemonList() {
      // this.sortSpecies()

      // create/update fusejs

      // let data = this.PokemonList.concat(this.ItemList)
      // this.fusejs.all = new Fuse(data, this.fusejs.options)
      this.fusejs.all = new Fuse(this.PokemonList, this.fusejs.options)
    }
  },
  computed: {
    ...mapGetters({
      PokemonList: 'pokemon/list',
      ItemList: 'item/list',
      IsActive: 'search/isActive',
    })
  },
  mounted() {
    document.addEventListener('keydown', this.updateInput)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.updateInput)
  },
  methods: {
    sortSpecies() {
      // sort forms
      let forms = []
      let species = []
      Object.assign(forms, this.PokemonList)
      Object.assign(species, this.PokemonList)
      for (let i = 0; i < forms.length; i++) {
        if (forms[i].is_default !== 0 || forms[i].form_name === '') {
          delete forms[i]
        }
      }
      for (let i = 0; i < species.length; i++) {
        if (species[i].is_default !== 1) {
          delete species[i]
        }
      }
      for (let i in species) {
        for (let j in forms) {
          if (species[i].species_id === forms[j].species_id) {
            if (typeof species[i].forms === 'undefined') {
              species[i].forms = [forms[j]]
            } else {
              species[i].forms.push(forms[j])
            }
          }
        }
      }
      this.sorted = species
    },
    updateInput(event) {
      if (event.ctrlKey) {
        return
      }
      // right key
      if (event.key === 'ArrowRight' && this.result.length > (this.selectedResult + 1) && this.maxResult > (this.selectedResult + 1)) {
        this.selectedResult++
        return
      }
      // left key
      if (event.key === 'ArrowLeft' && this.selectedResult - 1 >= 0) {
        this.selectedResult--
        return
      }
      // enter (go to pokemon details)
      if (event.key === 'Enter' && this.selectedResult >= 0) {
        // let pokemon = this.result[this.selectedResult]
        // let identifier = pokemon.forms && pokemon.forms[0].is_battle_only === 0 ? pokemon.identifier : pokemon.species_identifier
        let identifier = this.result[this.selectedResult].identifier
        this.query = ''
        this.reset()
        this.goPokemon(identifier)
        return
      }
      // escape (clear query)
      if (event.key === 'Escape') {
        this.reset()
        return
      }
      // backspace (delete query trailing character)
      if (event.key === 'Backspace') {
        this.query = this.query.slice(0, this.query.length - 1)
        if (this.query === '') {
          this.reset()
          return
        }
      }
      // max query length reached
      if (this.query.length >= this.maxQueryLength) {
        return
      }
      // if key is in list of available keys
      if (this.allowedChars.indexOf(event.key) !== -1) {
        this.query += event.key
        // can set a proper timeout here
      } else if (event.key !== 'Backspace') {
        return
      }
      // if search is not active, activate it
      if (!this.IsActive) {
        this['search/setIsActive'](true)
      }
      // clear results if the query is smaller than minQueryLength
      if (this.minQueryLength > 1 && this.query.length < this.minQueryLength) {
        if (this.result.length) {
          this.result = []
        }
        return
      }
      // search after timeout
      clearTimeout(this.fusejs.delay.v)
      this.fusejs.delay.v = setTimeout(() => {
        this.result = this.fuzz('all')
        if (this.result.length) {
          // set the first result as selected
          this.selectedResult = 0
        }
        if (this.maxResult >= 0 && this.result.length > this.maxResult) {
          this.result.length = this.maxResult
          this.resultHasMore = true
        } else {
          this.resultHasMore = false
        }
        // console.log('result "' + this.query + '"')
        // console.log(this.result)
        // if (this.result.length) {
        // 	// search in results for -mega
        // }
      }, this.fusejs.delay.t)
    },
    fuzz(t) {
      if (this.fusejs[t] === null) {
        return false
      }
      if (this.query.trim() === '') {
        return ''
      }
      return this.fusejs[t].search(this.query.trim())
    },
    reset() {
      this.query = ''
      this.result = []
      this.resultHasMore = false
      this['search/setIsActive'](false)
    },
    goPokemon(identifier) {
      this['search/setIsActive'](false)
      this.reset()
      this.$router.push('/pokemon/' + identifier)
    },
    ...mapActions([
      'search/setIsActive'
    ])
  },
}
</script>


<style lang="scss">
@import "~@/assets/css/variables.scss";

#search {
  position: fixed;
  top: 58px;
  left:0;
  width: 100%;
  z-index: 999;
  .query {
    font-size: 40px;
    font-weight: 700;
    width:100%;
    color: $white;


    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    background-color: $grey-darker;
    font-size: 26px;
    font-weight: 400;
    letter-spacing: .1rem;
    width:80%;
    margin:auto;
    border:1px solid $grey;
    border-radius: 10px;

    span.reset {
      margin-left: 20px;
      cursor: pointer;
      &:hover {
        color: $danger;
      }
    }
  }
  .results {
    overflow-x: auto;
    white-space: nowrap;
    background-color: $black-bis;
    background-color: #4b5252;
    padding-bottom: 20px;
    box-shadow: 0 -1px 12px $black;
    padding: 10px 0;
    > div.item img {
      display: inline;
    }
    > div:not(.query) {
      display: inline-block;
      vertical-align: top;
      // float:left;
      // $b: 1px solid #bdbdbd;
      // border-left: $b;
      // padding: 5px 15px 2px;
      padding: 10px 20px 7px;
      position: relative;
      // &:first-of-type {
      // 	border-left: none;
      // }
      &.is-selected {
        background-color: $grey-darker;
      }
      .imgwrap {
        min-height: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      img {
        display: block;
        margin: 0 auto;
      }
      span {
        &.species-name {
          font-size: 22px;
          text-align: center;
        }
      }
      // p.types {
      // 	span {}
      // }
      .forms {
        white-space: normal;
        width:120px;
        span {
          width: 40px;
          margin-top:5px;
          cursor: pointer;
          &:hover {
            border-radius: $radius;
            background-color: rgba(255,255,255,.1)
          }
          img {
            width:40px;
            height:30px;
          }
        }
      }
      > pre {
        display: none;
      }
    }
  }
}
</style>

